export default {
  common: {
    login: 'Accedi',
    logout: 'Esci',
    support: 'Assistenza',
    privacy: 'Politica sulla privacy',
    terms: `Termini e condizioni di utilizzo`,
    and: 'e',
    guest: 'Ospite',
    play: 'Gioca',
    install: 'Installa',
  },
  support: {
    title: `Hai bisogno di contattare l'assistenza?`,
    description: `Se stai riscontrando delle difficoltà in questo gioco,
      saremo lieti di aiutarti e rispondere a tutte le tue domande`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Aiuta Austin il maggiordomo a portare calore ed eleganza nella sua magnifica villa di famiglia.',
    description: `Aiuta Austin il maggiordomo a portare calore ed eleganza
      nella sua magnifica villa di famiglia. Forza! Le avventure
      inizieranno non appena varcherai la soglia!`,
  },
  cookie: {
    message: 'Questo sito utilizza i cookie per garantire una ottimale esperienza di navigazione',
    link: `Ulteriori informazioni`,
    button: 'Accetta',
  },
  install: {
    title: '@:common.install',
    text: `Homescapes sul tuo computer!
    Installa la versione web del gioco e vieni a trovare Austin: ci vorranno soltanto un paio di clic!`,
    button: '@:common.install',
  },
  copy: {
    xsolla: 'Xsolla è un distributore globale autorizzato di Homescapes',
  },
  game: {
    notSupported: `I dispositivi mobili non sono supportati.
      Accedi dal tuo computer per giocare.`,
  },
};
